import { useGetArticlesRelatedToPersonQuery } from 'redux/apis/blog';
import { useFetchPageQuery } from 'redux/apis/page';
import { getBreadcrumbs } from 'utils/breadcrumbs';
import isEmpty from 'lodash/isEmpty';
import { PAGES } from 'utils/constants';
import {
  getDocumentFields,
  getFileUrl,
  rootUrl,
} from 'utils/helper';
import { routes } from 'utils/routes';

export default ({
  query,
  currentPage,
  introSection,
  articlesNumberPerPage,
}) => {
  const { data = {} } = useFetchPageQuery(query.slug, { skip: Boolean(query.pageData) });

  const page = isEmpty(data) ? query.pageData : data;

  const {
    metaTitle,
    metaDescription,
    slug,
  } = page;

  const contentModules = page.contentModules ?? [];

  const [personModule, ...pageContentModules] = contentModules;
  const personData = personModule?.fields ?? {};

  const {
    title: fullName,
    subtitle: position,
    contentModules: socialLinks = [],
    bio,
    images = [],
  } = personData;

  const personMetadata = {
    metaTitle,
    metaDescription,
    url: `${rootUrl}${routes.person.getRoute(query?.slug).path}`,
    pageNumber: currentPage,
  };

  const breadcrumbs = getBreadcrumbs(PAGES.person, {
    slug: query?.slug,
    title: position,
  });

  const additionalMicrodata = {
    name: fullName,
    url: `${rootUrl}${routes.person.getRoute(query?.slug).path}`,
    image: getFileUrl(images[0]),
    sameAs: socialLinks.map((link) => {
      const { url } = getDocumentFields(link, ['url']);

      return url;
    }),
    jobTitle: position,
    description: bio,
  };

  let articles;

  const { data: articlesData } = useGetArticlesRelatedToPersonQuery(query);
  const { data: articlesDataNew } = useGetArticlesRelatedToPersonQuery({ ...query, id: '' });

  articles = articlesData;

  if (!articlesData?.total) {
    articles = articlesDataNew;
  }

  return {
    type: slug,
    currentPage,
    articlesNumberPerPage,
    pageData: pageContentModules,
    articlesData: articles,
    additionalMicrodata,
    breadcrumbs,
    personMetadata,
    introSection,
  };
};
